import { render, staticRenderFns } from "./TextMeshPro.vue?vue&type=template&id=6742ed40&"
import script from "./TextMeshPro.vue?vue&type=script&lang=js&"
export * from "./TextMeshPro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports